import { HttpOptions, UriFunction } from '@apollo/client'
import { FieldNode, OperationDefinitionNode } from 'graphql'

import { hashCode } from '@emico/utils'

const makeReadableQueryId: UriFunction = (operation) => {
  const operationDefinitions = operation.query.definitions.filter(
    (d) => d.kind === 'OperationDefinition',
  ) as OperationDefinitionNode[]

  const isMutation = operationDefinitions[0]?.operation === 'mutation'
  const operationNames = operationDefinitions
    .map((odn) => odn.selectionSet.selections[0])
    .filter((fn): fn is FieldNode => fn.kind === 'Field')
    .map((fn) => fn.name.value)
    .join(',')

  const query = new URLSearchParams(operation.variables).toString()

  return [
    // Queries are the default so don't need no prefix, and only prefixing
    // mutations just makes them stand out more. This is a bonus.
    isMutation && 'm',
    operationNames,
    // Make the variables as readable as possible, show a part of the query. But
    // not in full since this could result in too long urls.
    query.substr(0, 60),
    // Since this query ID can be used for caching, we need to differentiate
    // the request fields.
    hashCode(JSON.stringify(operation.variables)),
    hashCode(JSON.stringify(operation.query)),
  ]
    .filter((a) => a)
    .join('/')
}

// Add a unique id to URLs to make the network tab easier to read when debugging
const makeHttpLinkUri = (baseUri: string): HttpOptions['uri'] => (_operation) => baseUri

export default makeHttpLinkUri
